import React, { useEffect, useState } from "react";
import { Input, Space, Form, Button, message, Modal, notification } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { GrUpload } from "react-icons/gr";


import {
  Image,
  Select,
  TimePicker,
  Upload,
} from "antd";
import webserviceRequest from "./webserviceRequest";
const initialFilter = { page: 1, limit: 10 };

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


function WebServiceCreate() {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const [websiteFileList, setWebsiteFileList] = useState([]);
  const [mobileFileList, setMobileFileList] = useState([]);
  const navigate = useNavigate()
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [videoList, setVideoList] = useState([]);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState(initialFilter);
  const [pathType, setPathType] = useState(''); // Store selected pathType
  const [pathIdOptions, setPathIdOptions] = useState([]); // Store fetched pathId options
  const [options, setOptions] = useState([]); // Options for select
  
  const { Option } = Select;

  const onFinish = (values) => {
    console.log(values)
   
      setLoading(true);
      const allFormData = { ...values };
      console.log("allFormData", allFormData)
      webserviceRequest.createService(allFormData)
        .then((res) => {
          console.log("API Response:", res);
          if (res.status === 201) {
            notification.success({
              message: "Service added successfully",
            });
            navigate(-1);
          } else {
            notification.error({
              message: "Something went wrong",
            });
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          notification.error({
            message: "Failed to add service",
          });
          console.error("API Error:", e);
        });
    
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

   const handleImageChange = ({ fileList: newFileList }) => setFileList(newFileList);
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
    >
      <GrUpload />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const imageUpload = (file, name) => {
    setLoading(true);

    const modifiedFile = new File([file], name, { type: file.type });
    let formData = new FormData();
    formData.append("file", modifiedFile);
    formData.append("fileName", name);
    webserviceRequest
      .uploadImage(formData)
      .then((res) => {
        setLoading(false);
        form.setFieldsValue({
          imageUrl: res?.data?.uploadDirectory,

        });
        console.log(res)
        if (res) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "File upload Failed",
        })
      }
      );
  };


 const props = {
      name: "file",
      multiple: false,
      accept : "image/*",
      beforeUpload: (file) => {
        const isImage = file.type.startsWith("image/");
        if(!isImage){
          notification.error({
            message : "Invalid file type",
            description : "Only image files are allowed (jpg, png, jpeg, webp)",
          });
          return Upload.LIST_IGNORE; 
        }
        imageUpload(file, file.name);
        return false;
      },
      onRemove() {
        setFileList([]);
      },
    };


  return (
    <div>
      <section>
        <div className="Create-Category">
          <Form.Item className=" submit-btn">
            <Space>
              <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                <ArrowLeftOutlined />
              </Button>
            </Space>
          </Form.Item>
          <h3>Add Website Services</h3>


          <Form
            layout="vertical"
            className="subscription-form"
            form={form}
            onFinish={onFinish}
          >
            <div className="subscription">
              <Form.Item
                label="Service Name"
                name="serviceName"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter service name" },
                  {
                    pattern: /^[A-Za-z\s]+$/,
                    message: "Service name can only contain alphabetic characters!",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter service Name" />
              </Form.Item>

              <Form.Item
                label="Status"
                name="status"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select status" },
                ]}
              >
                <Select
                  placeholder="Select status"
                  // style={{
                  //   marginTop: "0.5rem",

                  //   width: "99%",
                  // }}
                  onChange={handleChange}
                  options={[
                    {
                      value: "0",
                      label: "Inactive",
                    },
                    {
                      value: "1",
                      label: "Active",
                    },

                  ]}
                />
              </Form.Item>
            </div>

            <div className="subscription">
              <Form.Item
                label="Title"
                name="title"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please enter service title" },
                 {
                                    pattern: /^[A-Za-z\s]+$/,
                                    message: "Title can only contain alphabetic characters!",
                                  },
                ]}
              >
                <Input size="large" placeholder="Enter title Name" />
              </Form.Item>
       <Form.Item
  label="Description"
  name="description"
  className="subscription-plan"
  rules={[
    {
      required: true,
      message: "Please enter description",
    },
    {
      min: 10,
      message: "Description must be at least 10 characters",
    },
    {
      max: 500,
      message: "Description cannot exceed 500 characters",
    },
    {
      pattern: /^[A-Za-z0-9\s,.'!@#&()\-_:;/?]+$/,
      message:
        "Description contains invalid characters!",
    },
  ]}
>
  <Input.TextArea
    rows={4}
    placeholder="Enter description"
  />
</Form.Item>
            </div>

        
            <div className="subscription">
              <Form.Item
                label="Order By"
                name="orderBy"
                className="subscription-plan"
                rules={[
                  { required: true, message: "Please select order" },
                ]}
              >
                <Select
                  placeholder="Select order"
               
                  onChange={handleChange}
                  options={[
                    {
                      value: "1",
                      label: "1",
                    },
                    {
                      value: "2",
                      label: "2",
                    },
                    {
                      value: "3",
                      label: "3",
                    },
                    {
                      value: "4",
                      label: "4",
                    },
                    {
                      value: "5",
                      label: "5",
                    },

                  ]}
                />
              </Form.Item>

            </div>


            {/* <div className="upload-Img">
              <Form.Item
                label="Upload Service image"
                name="imageUrl"
                rules={[{ required: true, message: "Please upload the Image" }]}
              >
                <Upload
                  {...props}
                  maxCount={1}
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={handlePreview}
                  onChange={handleImageChange}
                >
                  {fileList.length >= 1 ? null : uploadButton}
                </Upload>
              </Form.Item>
            </div> */}
               <div className="upload-Img">
                          <Form.Item
                            label="Upload Salon Images"
                            name="imageUrl"
            
                            rules={[
                              {
                                required: true,
                                message: "Please upload the salon images",
                              },
                            ]}
                          >
                            <Upload
                              {...props} maxCount={1}
                              listType="picture-card"
                              fileList={fileList}
                              onPreview={handlePreview}
                              onChange={handleImageChange}
                            >
                              {fileList.length >= 1 ? null : uploadButton}
                            </Upload>
                            {previewImage && (
                              <Image
                                wrapperStyle={{
                                  display: "none",
                                }}
                                preview={{
                                  visible: previewOpen,
                                  onVisibleChange: (visible) => setPreviewOpen(visible),
                                  afterOpenChange: (visible) =>
                                    !visible && setPreviewImage(""),
                                }}
                                src={previewImage}
                              />
                            )}
                          </Form.Item>
                        </div>

          

            <div className="bottom-button">
              <div style={{ padding: "10px" }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Save & Proceed
                  <span>
                    <AiOutlineRight />
                  </span>
                </Button>
              </div>
            </div>

          </Form>
        </div>
      </section>
    </div>
  )
}

export default WebServiceCreate
